import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import { NameCell as BaseCell } from '@openx/components-core/lib/NameCell/NameCell.tsx';
import type { OrganizationsList, OrganizationTreeRowData } from '@openx/types/organization.ts';
import { useMemo } from 'react';
import { AccountHierarchy } from './AccountHierarchy.tsx';
import { ExpandButton } from './ExpandButton.tsx';
import { buildAccountHierarchy } from './utils.ts';

export type NameCellProps = {
  organization: OrganizationTreeRowData;
  parentOrganizations: Pick<OrganizationsList, 'id' | 'name'>[];
  searchPhrase?: string;
};

export const NameCell = ({
  organization: { children, name, id, depth = 0, expanded = false, path_to_root = [] },
  parentOrganizations,
  searchPhrase,
}: NameCellProps) => {
  const isExpandable = !!children?.length;
  const isFilteringEnabled = !!searchPhrase;

  const accountHierarchy = useMemo(
    () => buildAccountHierarchy(id, name, path_to_root, parentOrganizations),
    [id, name, path_to_root, parentOrganizations]
  );

  return (
    <Box
      data-test="name-cell"
      sx={{
        alignItems: 'center',
        display: 'flex',
        paddingLeft: depth * 4,
      }}
    >
      {!isFilteringEnabled && (
        <>
          {isExpandable && <ExpandButton expanded={expanded} />}
          {!isExpandable && <IconButton size="small" disabled sx={{ mr: 2 }} />}
        </>
      )}

      <BaseCell
        data-test="row-title"
        id={id}
        name={name}
        pathTo={`/organizations/${id}/details`}
        searchPhrase={searchPhrase}
      >
        {isFilteringEnabled && <AccountHierarchy accountHierarchy={accountHierarchy} />}
      </BaseCell>
    </Box>
  );
};
